// Mirrors the box model of ProductCard (both the /products grid card and the
// homepage FeaturedProducts card) so the loading grid reserves the same height
// as the loaded grid — keeps the footer from jumping when real cards paint.
//
// Body height is pinned to 168px: measured live (2026-09-06) as the rendered
// height of src/components/products/ProductCard.tsx's CardContent with a 3-line
// line-clamp-3 title — the dominant case in the /products grid (~80% of cards;
// the other ~20% are 2-line at 148px). The old skeleton reserved only the
// 2-line height, so every 3-line row grew ~20px on the loading→loaded swap and
// dropped the grid + everything below it (the /products CLS 0.001 → 0.047
// regression in the S55 Lighthouse run). Body height is width-independent
// across the grid's 2→6-col breakpoints (card width stays ~174–200px, title
// wraps to 2–3 lines throughout).
const ProductCardSkeleton = () => {
  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm h-full flex flex-col overflow-hidden animate-pulse">
      {/* Image — same aspect-square box the real card uses */}
      <div className="aspect-square w-full bg-gray-200" />

      {/* Body — matches CardContent's p-3 + 3-line title + price + full-width button */}
      <div className="min-h-[168px] p-3 flex-1 flex flex-col gap-2">
        <div className="h-3 bg-gray-200 rounded" />
        <div className="h-3 bg-gray-200 rounded w-5/6" />
        <div className="h-3 bg-gray-200 rounded w-2/3" />
        <div className="h-5 bg-gray-200 rounded w-1/2 mt-1" />
        <div className="h-8 bg-gray-200 rounded w-full mt-auto" />
      </div>
    </div>
  );
};

export default ProductCardSkeleton;
